import React, { createContext, useContext, useState, useEffect } from "react";

const LangCtx = createContext({ lang: "EN", setLang: () => {} });

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("aloha_lang") || "EN");
  useEffect(() => { localStorage.setItem("aloha_lang", lang); }, [lang]);
  return <LangCtx.Provider value={{ lang, setLang }}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);

// minimal nav translations
export const NAV_T = {
  EN: { home: "Home", transfers: "Transfers", tours: "Tours & Experiences", fleet: "Fleet", about: "About Us", guide: "Corfu Guide", contact: "Contact", book: "Book Now" },
  GR: { home: "Αρχική", transfers: "Μεταφορές", tours: "Εκδρομές", fleet: "Στόλος", about: "Σχετικά", guide: "Οδηγός Κέρκυρας", contact: "Επικοινωνία", book: "Κράτηση" },
};

export const useReveal = () => {
  useEffect(() => {
    const els = document.querySelectorAll(".reveal:not(.in)");
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  });
};
